// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__OiEGQ","footer":"ChangeClinic_footer__3TJMP"};